import { SagaIterator } from "redux-saga";
import { put, call, takeLatest } from "redux-saga/effects";
import { setErrorsCreatePushNotification, setPushNotificationLoading } from "../../repository/actions";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";

function* createPushNotificationWorker({ payload }: any): SagaIterator {
    try {
        yield put(setPushNotificationLoading(true));
        const formData = new FormData();
        for (const [key, value] of Object.entries(payload as Object)) {
            const isValue = value !== null && value !== undefined && value !== "";
            if (isValue) {
                if (Array.isArray(value)) {
                    formData.append(key, JSON.stringify(value))
                } else {
                    formData.append(key, value);
                };
            }
        };
        const { data, isError, message }: IResponse<any> = yield call( requester.post, "/api/user-notification", formData, { "Content-Type": "multipart/form-data" });
        if (isError) {
            yield put(setErrorsCreatePushNotification(message));
        } else {
            yield put(setErrorsCreatePushNotification(null));
        }
    } catch (error) {
        console.error("createPushNotificationWorker: ", error);
    } finally {
        yield put(setPushNotificationLoading(false));
    }
};

export function* createPushNotificationWatcher() {
    yield takeLatest("@saga/CREATE_PUSH_NOTIFICATION", createPushNotificationWorker);
};
